module.exports = __webpack_public_path__ + "img/sandy_grotta.f3bb2637.jpg";